<span class="loading-indicator" role="status" [attr.aria-label]="label"></span>
